import React from 'react';

import FlatButton from '../../../FlatButton';

import { Squeeze } from '../../helper';

import styles from '../../pagination.module.scss';

type PageButtonsProps = {
  pageList: Array<number | Squeeze>;
  activePage: number;
  limit: number;
  onChangePage: (offset: number, limit: number) => void;
  buttonType?: 'light' | 'dark' | 'simple' | 'outlined';
};

export default function PageButtons(props: PageButtonsProps) {
  const { pageList, activePage, limit, onChangePage, buttonType } = props;

  return (
    <span className={styles.body} data-testid="pageButtons-wrapper">
      {pageList.map(item => {
        if (typeof item === 'object') {
          return (
            <span
              data-testid="pageButtons-symbol"
              key={item.id}
              className={buttonType === 'outlined' ? styles.outlinedDots : styles.pageGap}
            >
              {item.symbol}
            </span>
          );
        }

        const handleButtonChangePage = () => {
          onChangePage(limit * (item - 1), limit);
        };

        if (item === activePage) {
          return buttonType === 'outlined' ? (
            <button
              key={item}
              className={styles.activeWithoutBox}
              onClick={handleButtonChangePage}
              data-testid="pageButtons-activeItem"
            >
              {activePage}
            </button>
          ) : (
            <FlatButton
              className={styles.active}
              key={item}
              onClick={handleButtonChangePage}
              data-testid="pageButtons-activeItem"
            >
              {activePage}
            </FlatButton>
          );
        }

        return buttonType === 'outlined' ? (
          <button
            key={item}
            className={styles.normalWithoutBox}
            onClick={handleButtonChangePage}
            data-testid="pageButtons-item"
          >
            {item}
          </button>
        ) : (
          <FlatButton
            key={item}
            className={styles.normal}
            onClick={handleButtonChangePage}
            classType="secondary"
            data-testid="pageButtons-item"
          >
            {item}
          </FlatButton>
        );
      })}
    </span>
  );
}
